import { Box, Typography } from '@mui/material';

import { SHRED_COLORS, SHRED_COPY, SHRED_FONTS } from '../constants';
import { formatAwardValue } from '../helpers';
import { LevelChip, MemberAvatar, SectionTitle } from './shared';

// Final-results view: one "trophy" per award with the champion's name on the plaque.
const Shelf = ({ awards, isMine }) => {
  const decided = awards.filter((award) => award.winners.length > 0);
  if (decided.length === 0) return null;
  return (
    <Box component="section" aria-labelledby="shred-shelf-title">
      <SectionTitle kicker="Final results" title={SHRED_COPY.SHELF_TITLE} hint={SHRED_COPY.SHELF_SUBTITLE} id="shred-shelf-title" />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', md: 'repeat(3, minmax(0, 1fr))' },
          gap: 1.5,
          pb: 2,
          borderBottom: `6px solid ${SHRED_COLORS.panelRaised}`,
          boxShadow: '0 10px 0 -4px rgba(255,138,31,0.25)',
        }}
      >
        {decided.map((award) => {
          const winner = award.winners[0];
          return (
            <Box
              key={award.id}
              sx={{
                textAlign: 'center',
                minWidth: 0,
                p: 1.5,
                borderRadius: '14px 14px 4px 4px',
                background: `linear-gradient(180deg, ${award.accent}2e, ${SHRED_COLORS.panel} 70%)`,
                border: `1px solid ${award.accent}55`,
                boxShadow: isMine(winner) ? `0 0 0 2px ${SHRED_COLORS.gold}` : 'none',
              }}
            >
              <Box aria-hidden="true" sx={{ fontSize: 44, lineHeight: 1, filter: `drop-shadow(0 4px 10px ${award.accent}99)` }}>🏆</Box>
              <Typography sx={{ mt: 0.5, fontFamily: SHRED_FONTS.display, fontWeight: 800, fontSize: 20, textTransform: 'uppercase', color: award.accent, lineHeight: 1.05 }}>
                {award.title}
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                <MemberAvatar id={winner.id} name={winner.username} size={48} ring={award.accent} />
              </Box>
              <Typography noWrap sx={{ mt: 0.75, fontFamily: SHRED_FONTS.display, fontWeight: 700, fontSize: 20 }}>{winner.username}</Typography>
              <LevelChip level={winner.level} />
              <Typography sx={{ mt: 0.5, fontFamily: SHRED_FONTS.numeric, fontSize: 13, color: SHRED_COLORS.gold }}>
                {formatAwardValue(award.valueUnit, winner.value)}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Shelf;
